import { Grid, TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { makeStyles } from '@material-ui/core/styles';
import Content from '../ContentForLookupCodes';
import { getService } from 'reducers/service';
import LookupPage from './Menu';
import LookUpCodesAddEditDialog, {
  ibrsVersionMaintainableTables,
} from './../../Dialogs/LookUpCodes/AddEditDialog';
import settings from 'config/settings';
import { displayDate } from 'reducers/TimeReducer';
import MergeIcon from '@mui/icons-material/Merge';
import {
  partyRelationshipColumns,
  codeCitiesColumns,
  commonColumns,
  codeDispositionColumns,
  codeZonesColumns,
  codeUnitActionColumns,
  codeVehicleMakeModelsColumns,
  codeZonesCols,
  codeTagTypesColumns,
  renderStatutesColumn,
  codeIncidentTypesColumns,
  CallMethodsColumns,
  evidenceStorageSublocationColumns,
  commonColumnsWithAgencyId,
  codeEvidencePropertyTypeColumns,
  codeEvidenceCustodyStatusColumns,
} from './CodeTableColumns';
import Spinner from 'components/Spinner';
import ReorderableGrid from './ReorderableGrid';
import services from './serviceNames';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import QuickFilter from 'components/QuickFilter';
import { Autocomplete } from '@material-ui/lab';
import { showMergeCities } from 'reducers/DialogsReducer';
import CitationCourt from 'Settings/Mobile/CitationCourt';
import PrintIcon from '@material-ui/icons/Print';
import SaveIcon from '@material-ui/icons/Save';
import ReportsDialog from 'Dialogs/ReportsDialog';
import { checkReportPermission } from 'utils/functions';
import store from '../../config/configureStore';

export const agencyCodeServices = [
  'codeevidencecustodyreason',
  'codeevidencecustodystatus',
  'codeevidencedestructionways',
  'codeevidencedisposalcode',
  'codeevidencecategory',
  'codeevidencetype',
  'codeevidencefinaldisposition',
  'codeevidencerequiredaction',
  'codeevidencestoragecontainer',
  'codeevidencestoragelocation',
  'codeevidencestoragesublocation',
  'codeevidencecheckoutlocation',
  'codeevidencecheckoutreason',
  'codeevidencepropertytype',
  'codeevidencetemporarylocation',
  'codeevidencecorrectionreason',
];

const useStyles = makeStyles(theme => ({
  list: {
    width: '100%',
    height: `calc(100vh - 190px)`,
  },
  wrap: {
    padding: theme.spacing(2),
    '& > h5': {
      marginBottom: 20,
    },
  },
 searchBar: {
  padding: theme.spacing(1, 0, 2),
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
},
 actions: {
  marginLeft: 'auto',
  padding: theme.spacing(1, 0, 2),
  textAlign: 'right',
  '& button': {
    marginLeft: theme.spacing(1),
  },
},
  parentFilter: {
    minWidth: '200px',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  pageWrap: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.colors.paper,
  },
  menu: {
    height: `calc(100vh - ${settings.mainNavHeight}px)`,
    overflowY: 'scroll',
  },
  content: {
    flex: 1,
  },
  rightControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  agencyFilter: {
    minWidth: 200,
  },
}));
const SORT_ORDER_FIELD = 'SortOrder';
function LookupCodes() {
  const [columns, setColumns] = useState(commonColumns);
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [item, setItem] = useState('');
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('');
  const [editableRow, setEditableRow] = useState({});
  const [selection, setSelection] = useState([]);
  const [currentService, setCurrentService] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);
  const dictionary = useSelector(state => state.dictionary);
  const handleSelectChange = ({ selectionModel }) => setSelection(selectionModel);
  const [filteredRows, setFilteredRows] = useState([]);
  const [parentFilter, setParentFilter] = useState(null);
  const [showReportDialog, setShowReportDialog] = useState(false);
  const [orderDirty, setOrderDirty] = useState(false);
  const [reportData, setReportData] = useState({});
  const dispatch = useDispatch();
  const currentAgency = store.store.getState().user.userData.user.AgencyID;
  const [agencyFilter, setAgencyFilter] = useState(currentAgency || null);
  const [agencyFilterOptions, setAgencyFilterOptions] = useState([]);
  const tagTypeOptions = window.location.pathname.includes('code-Tag-Types-Cad')
    ? ['CAD Event', 'CAD Unit Status']
    : ['Incident', 'Person'];
  const isReorderable = agencyCodeServices.includes(currentService);
  const dirtyRowIdsRef = useRef(new Set());
  const resetOrderDirtyState = () => {
    dirtyRowIdsRef.current = new Set();
    setOrderDirty(false);
  };
  const handleRowsReordered = newOrderOfVisibleRows => {
    const originalIdOrder = filteredRows.map(r => String(r.PtsCodeID));
    const newIdOrder = newOrderOfVisibleRows.map(r => String(r.PtsCodeID));
    const orderActuallyChanged =
      originalIdOrder.length !== newIdOrder.length ||
      originalIdOrder.some((id, idx) => id !== newIdOrder[idx]);

    if (!orderActuallyChanged) return;

    const visibleIdSet = new Set(newOrderOfVisibleRows.map(r => r.PtsCodeID));
    const slotIndexes = [];
    rows.forEach((row, idx) => {
      if (visibleIdSet.has(row.PtsCodeID)) {
        slotIndexes.push(idx);
      }
    });
    const renumberedVisibleRows = newOrderOfVisibleRows.map((row, i) => ({
      ...row,
      [SORT_ORDER_FIELD]: slotIndexes[i] + 1,
    }));

    const updatedRows = [...rows];
    renumberedVisibleRows.forEach((newRow, i) => {
      const targetIdx = slotIndexes[i];
      if (targetIdx == null) return;
      updatedRows[targetIdx] = newRow;
    });

    setRows(updatedRows);
    setFilteredRows(renumberedVisibleRows);
    setOrderDirty(true);
  };

  const handleSaveOrder = async () => {
    if (!orderDirty) return;

    try {
      setShowSpinner(true);
      const service = getService(currentService);
      await Promise.all(
        rows.map(row => service.update(row.PtsCodeID, row))
      );
      resetOrderDirtyState();
    } catch (error) {
      await getLookUpCodes(currentService, agencyFilter);
    } finally {
      setShowSpinner(false);
    }
  };

  const handleClickOnListItem = async item => {
    setCurrentService(item.service);
    if (item.service !== 'citation-court') {
      getColumns(item.service);
      const needsAgencyFilter =
        agencyCodeServices.includes(item.service) ||
        ['code-dispositions', 'codezonetypes', 'codezones'].includes(item.service);

      if (needsAgencyFilter) {
        const service = getService('ptsagencies');
        const response = await service.find({
          query: { $select: ['AgencyID'], IsDeleted: false, $limit: 0 },
        });
        const options = response?.data?.map(el => el.AgencyID) || [];
        const defaultAgency = options.includes(currentAgency) ? currentAgency : options[0] || null;

        setAgencyFilterOptions(options);
        setAgencyFilter(defaultAgency);
        await getLookUpCodes(item?.service, defaultAgency);
      } else {
        setAgencyFilter(null);
        setAgencyFilterOptions([]);
        await getLookUpCodes(item?.service, null);
      }
    }
    setItem(item);
  };

  const handleClose = async () => {
    const needsAgencyFilter = agencyCodeServices.includes(currentService);
    await getLookUpCodes(item?.service, needsAgencyFilter ? agencyFilter : null);
    setMode('');
    setOpen(false);
  };

  const getLookUpCodes = async (serviceName, selectedAgency = null) => {
    try {
      setShowSpinner(true);
      const service = getService(serviceName);

      const query = { IsDeleted: false, $limit: 0 };
      if (selectedAgency) {
        query.$or = [{ AgencyID: selectedAgency }, { AgencyID: null }];
      }
      if (agencyCodeServices.includes(serviceName)) {
        query.$sort = { [SORT_ORDER_FIELD]: 1 };
      }

      const codes = await service.find({ query });
      const data = getData(serviceName, codes);

      setRows(data);
      resetOrderDirtyState();
      setShowSpinner(false);
    } catch (error) {
      console.log('error ', error);
      setShowSpinner(false);
    }
  };

  const handleAgencyFilterChange = async selectedAgency => {
    setAgencyFilter(selectedAgency);
    await getLookUpCodes(currentService, selectedAgency);
  };

  const onClickAdd = () => {
    setMode('add');
    setEditableRow({});
    setOpen(true);
  };
  const onClickEdit = () => {
    const obj = getEditableObject();
    setEditableRow(obj);
    setMode('edit');
    setOpen(true);
  };

  const onClickPrint = id => {
    if (!checkReportPermission(id)) return;
    let data = {};
    if(agencyCodeServices.includes(currentService)) data = { AgencyId: agencyFilter };
    setReportData({
      id: id,
      title: 'Report',
      data: data,
    });
    setShowReportDialog(true);
    handleClose();
  };

  const onReportDialogClose = () => {
    setShowReportDialog(false);
  };

  /* Helper Functions -> start */
  const getColumns = serviceName => {
    let cols;
    if (ibrsVersionMaintainableTables.includes(serviceName)) {
      const modifiedColumn = [...commonColumns];
      modifiedColumn.splice(3, 0, {
        field: 'IBRSVersion',
        headerName: 'Version',
        width: 150,
      });
      cols = modifiedColumn;
    } else {
    switch (serviceName) {
      case 'codepartyrelationship':
        cols = partyRelationshipColumns;
        break;
      case 'codecities':
        cols = codeCitiesColumns;
        break;
      case 'code-dispositions':
        cols = codeDispositionColumns;
        break;
      case 'codezonetypes':
        cols = codeZonesColumns;
        break;
      case services.UNIT_ACTIONS:
        cols = codeUnitActionColumns;
        break;
      case 'code-vehicle-make-models':
        cols = codeVehicleMakeModelsColumns;
        break;
      case 'codezones':
        cols = codeZonesCols;
        break;
      case 'codetagtypes':
        cols = codeTagTypesColumns;
        break;
      case 'settings-ptsStatutes':
        cols = renderStatutesColumn;
        break;
      case 'codeincidenttypes':
        cols = codeIncidentTypesColumns;
        break;
      case 'codecadmethods':
        cols = CallMethodsColumns;
        break;
      case 'codeevidencestoragesublocation':
        cols = evidenceStorageSublocationColumns;
        break;
      case 'codeevidencepropertytype':
        cols = codeEvidencePropertyTypeColumns;
        break;
      case 'codeevidencecustodystatus':
        cols = codeEvidenceCustodyStatusColumns;
        break;
      case 'codeevidencecustodyreason':
      case 'codeevidencedestructionways':
      case 'codeevidencedisposalcode':
      case 'codeevidencecategory':
      case 'codeevidencetype':
      case 'codeevidencefinaldisposition':
      case 'codeevidencerequiredaction':
      case 'codeevidencestoragecontainer':
      case 'codeevidencestoragelocation':
      case 'codeevidencecheckoutlocation':
      case 'codeevidencecheckoutreason':
      case 'codeevidencetemporarylocation':
      case 'codeevidencecorrectionreason':
        cols = commonColumnsWithAgencyId;
        break;
      default:
        cols = commonColumns;
        break;
      }
    }
    setColumns(cols);
  };
  const getData = (serviceName, codes) => {
    let data;
    switch (serviceName) {
      case 'codecities':
        data = codes.data?.map(el => ({ ...el, id: el.ptsCityID }));
        break;
      case 'code-dispositions':
        data = codes.data?.map(el => ({
          ...el,
          id: JSON.stringify({ Code: el.Code, AgencyID: el.AgencyID }),
        }));
        break;
      case 'codezonetypes':
        data = codes.data?.map(el => ({ ...el, id: el.AgencyID }));
        break;
      case 'code-vehicle-make-models':
        data = codes.data?.map(el => ({
          ...el,
          id: JSON.stringify({ MakeCode: el.MakeCode, ModelCode: el.ModelCode }),
        }));
        break;
      case 'codezones':
        data = codes.data?.map(el => ({ ...el, id: el.ZoneCode }));
        break;
      case services.UNIT_ACTIONS:
        data = codes?.map(el => ({ ...el, id: el.Code }));
        break;
      case 'settings-ptsStatutes':
        data = codes?.map(el => ({ ...el, id: el.ptsStatuteID }));
        break;
      case 'codeevidencecustodyreason':
      case 'codeevidencecustodystatus':
      case 'codeevidencedestructionways':
      case 'codeevidencedisposalcode':
      case 'codeevidencecategory':
      case 'codeevidencetype':
      case 'codeevidencefinaldisposition':
      case 'codeevidencerequiredaction':
      case 'codeevidencestoragecontainer':
      case 'codeevidencestoragelocation':
      case 'codeevidencestoragesublocation':
      case 'codeevidencecheckoutlocation':
      case 'codeevidencecheckoutreason':
      case 'codeevidencepropertytype':
      case 'codeevidencetemporarylocation':
      case 'codeevidencecorrectionreason':
      case 'codepartyrelationship':
      case 'codesubstancecategory':
      case 'codedrugmeasurements':
        data = codes.data?.map(el => ({ ...el, id: el.PtsCodeID }));
        break;
      case 'codetagtypes':
        if (window.location.pathname.includes('code-Tag-Types-Cad')) {
          data = codes.data
            ?.filter(el => el.Parent === 'CAD Event' || el.Parent === 'CAD Unit Status')
            ?.map(el => ({ ...el, id: el.Code }));
        } else {
          data = codes.data
            ?.filter(el => el.Parent !== 'CAD Event' && el.Parent !== 'CAD Unit Status')
            ?.map(el => ({ ...el, id: el.Code }));
        }
        break;
      case 'codenibrsspecversions':
        // Code repeats across states (e.g. 2023.0 for NIBRS and TX), so key the
        // grid on the surrogate PK to keep row ids unique and editing addressable.
        data = codes.data?.map(el => ({ ...el, id: el.ptsNibrsSpecVersionID }));
        break;
      default:
        data = codes.data?.map(el => ({ ...el, id: el.Code }));
    }
    return data;
  };
  const getEditableObject = () => {
    let obj;
    switch (currentService) {
      case 'code-dispositions':
        // eslint-disable-next-line no-case-declarations
        const paramsDisp = JSON.parse(selection[0]);
        obj = rows.find(
          row => row.Code === paramsDisp.Code && row.AgencyID === paramsDisp.AgencyID
        );
        break;
      case 'codezonetypes':
        obj = rows.find(row => row.AgencyID === selection[0]);
        break;
      case 'codecities':
        obj = rows.find(row => JSON.stringify(row.ptsCityID) === selection[0]);
        break;
      case 'code-vehicle-make-models':
        // eslint-disable-next-line no-case-declarations
        const params = JSON.parse(selection[0]);
        obj = rows.find(
          row => row.MakeCode === params.MakeCode && row.ModelCode === params.ModelCode
        );
        break;
      case 'codezones':
        obj = rows.find(row => row.ZoneCode === selection[0]);
        break;
      case 'settings-ptsStatutes':
        obj = rows.find(row => row.ptsStatuteID == selection[0]);

        break;
      case 'codeevidencecustodyreason':
      case 'codeevidencecustodystatus':
      case 'codeevidencedestructionways':
      case 'codeevidencedisposalcode':
      case 'codeevidencecategory':
      case 'codeevidencetype':
      case 'codeevidencefinaldisposition':
      case 'codeevidencerequiredaction':
      case 'codeevidencestoragecontainer':
      case 'codeevidencestoragelocation':
      case 'codeevidencestoragesublocation':
      case 'codeevidencecheckoutlocation':
      case 'codeevidencecheckoutreason':
      case 'codeevidencepropertytype':
      case 'codeevidencetemporarylocation':
      case 'codeevidencecorrectionreason':
      case 'codepartyrelationship':
      case 'codesubstancecategory':
      case 'codedrugmeasurements':
        obj = rows.find(row => row.PtsCodeID == selection[0]);
        break;
      case 'codenibrsspecversions':
        // The grid id is the surrogate PK (Code repeats across states), so the
        // selection matches on ptsNibrsSpecVersionID, not Code.
        obj = rows.find(row => row.ptsNibrsSpecVersionID == selection[0]);
        break;
      default:
        obj = rows.find(row => row.Code === selection[0]);
        break;
    }
    return obj;
  };
  /* Helper Functions -> end */

  const onClickDelete = async () => {
    const service = getService(item?.service);
    let removeCode;
    let newRows;
    switch (currentService) {
      case 'code-dispositions':
        // eslint-disable-next-line no-case-declarations
        const paramsDisp = JSON.parse(selection[0]);
        removeCode = await service.remove({ Code: paramsDisp.Code, AgencyID: paramsDisp.AgencyID });
        newRows = rows.filter(
          el => el.Code !== paramsDisp.Code && el.AgencyID !== paramsDisp.AgencyID
        );
        break;
      case 'codezonetypes':
        removeCode = await service.remove(selection[0]);
        newRows = rows.filter(el => el.AgencyID !== removeCode.AgencyID);
        break;
      case 'code-vehicle-make-models':
        // eslint-disable-next-line no-case-declarations
        const params = JSON.parse(selection[0]);
        removeCode = await service.remove({
          MakeCode: params.MakeCode,
          ModelCode: params.ModelCode,
        });
        newRows = rows.filter(
          el => el.MakeCode !== params.MakeCode && el.ModelCode !== params.ModelCode
        );
        break;
      case 'settings-ptsStatutes':
        removeCode = await service.remove(selection[0]);
        newRows = rows.filter(el => el.ptsStatuteID !== removeCode.ptsStatuteID);
        break;
      case 'codezones':
        removeCode = await service.remove(selection[0]);
        newRows = rows.filter(el => el.ZoneCode !== removeCode.ZoneCode);
        break;
      case 'codeevidencecustodyreason':
      case 'codeevidencecustodystatus':
      case 'codeevidencedestructionways':
      case 'codeevidencedisposalcode':
      case 'codeevidencecategory':
      case 'codeevidencetype':
      case 'codeevidencefinaldisposition':
      case 'codeevidencerequiredaction':
      case 'codeevidencestoragecontainer':
      case 'codeevidencestoragelocation':
      case 'codeevidencestoragesublocation':
      case 'codeevidencecheckoutlocation':
      case 'codeevidencecheckoutreason':
      case 'codeevidencepropertytype':
      case 'codeevidencetemporarylocation':
      case 'codeevidencecorrectionreason':
      case 'codepartyrelationship':
      case 'codesubstancecategory':
      case 'codedrugmeasurements':
        removeCode = await service.remove(parseInt(selection[0]));
        newRows = rows.filter(el => el.PtsCodeID != removeCode.PtsCodeID);
        break;
      case 'codenibrsspecversions':
        // Remove by the surrogate PK and filter the grid by it too: Code repeats
        // across states, so a Code filter would drop the other state's row.
        removeCode = await service.remove(selection[0]);
        newRows = rows.filter(el => el.ptsNibrsSpecVersionID != selection[0]);
        break;
      default:
        removeCode = await service.remove(selection[0]);
        newRows = rows.filter(el => el.Code !== removeCode.Code);
        break;
    }
    setRows(newRows);
  };
  const onMergeClick = () => {
    const obj = rows.find(row => JSON.stringify(row.ptsCityID) === selection[0]);
    dispatch(showMergeCities({ data: obj, rows: rows, onClose: handleClose }));
  };
  const renderActions = () => {
    const disabled = selection.length === 0;
    //const selected = rows.find(a => a.id === selection[0]);
    //const dltDisabled = selected?.Icon === 0;
    return (
      <div className={classes.actions}>
        {item?.reportID > 0 && (
          <Fab
            size="small"
            color="secondary"
            disabled={
              !checkReportPermission(item.reportID) ||
              (agencyCodeServices.includes(currentService) && !agencyFilter)
            }
            onClick={() => onClickPrint(item.reportID)}>
            <PrintIcon />
          </Fab>
        )}
        {isReorderable && (
          <Fab
            size="small"
            color="primary"
            disabled={!orderDirty}
            onClick={handleSaveOrder}
            title="Save Order">
            <SaveIcon />
          </Fab>
        )}
        <Fab size="small" color="secondary" onClick={onClickAdd}>
          <AddIcon />
        </Fab>
        <Fab size="small" color="secondary" onClick={onClickEdit} disabled={disabled}>
          <EditIcon />
        </Fab>
        {currentService === 'codecities' && (
          <Fab size="small" color="secondary" disabled={disabled} onClick={onMergeClick}>
            <MergeIcon />
          </Fab>
        )}
        <Fab size="small" color="secondary" onClick={onClickDelete} disabled={disabled}>
          <DeleteIcon />
        </Fab>
      </div>
    );
  };

  useEffect(() => {
    const shouldShowAgencyFilter =
      agencyCodeServices.includes(currentService) ||
      ['code-dispositions', 'codezonetypes', 'codezones'].includes(currentService);

    if (!shouldShowAgencyFilter) {
      setAgencyFilterOptions([]);
      setAgencyFilter(null);
    }
  }, [currentService]);

  return (
    <Content>
      <div className={classes.pageWrap}>
        <Grid container style={{ padding: 10 }} spacing={2}>
          <Grid item xs={2}>
            <div className={classes.menu}>
              <LookupPage handleClickOnListItem={handleClickOnListItem} />
            </div>
          </Grid>
          <Grid item xs={10}>
            {item?.service === 'citation-court' ? (
              <CitationCourt />
            ) : Object.keys(item).length ? (
              <div className={classes.content}>
                <div className={classes.searchBar}>
                  <QuickFilter
                    rows={rows}
                    columns={columns}
                    setFilteredRows={setFilteredRows}
                    parentFilter={parentFilter}
                    currentService={currentService}
                  />
                  {agencyCodeServices.includes(currentService) && (
                    <Autocomplete
                      options={agencyFilterOptions}
                      value={agencyFilter}
                      size="small"
                      style={{ minWidth: 200 , marginTop: 24, marginBottom: 8}}
                      renderInput={params => (
                        <TextField {...params} label="Filter by Agency" variant="outlined" />
                      )}
                      onChange={(event, selection) => handleAgencyFilterChange(selection)}
                    />
                  )}

                  {currentService === 'codetagtypes' && (
                    <Autocomplete
                      options={tagTypeOptions}
                      value={parentFilter}
                      size="small"
                      className={classes.parentFilter}
                      renderInput={params => (
                        <TextField {...params} label="Parent Type" variant="outlined" />
                      )}
                      onChange={(event, selection) => setParentFilter(selection)}
                    />
                  )}
                  {renderActions()}
                </div>
                {showSpinner && <Spinner />}
                {!showSpinner && rows?.length ? (
                  <div className={classes.list}>
                    <ReorderableGrid
                      // autoPageSize
                      componentsProps={{
                        panel: {
                          style: {
                            top: '-120px !important',
                          },
                        },
                      }}
                      columns={columns}
                      rows={filteredRows}
                      pageSize={
                        isReorderable ? Math.min(Math.max(filteredRows.length, 10), 500) : 10
                      }
                      onSelectionModelChange={handleSelectChange}
                      onRowsReordered={handleRowsReordered}
                      enableRowReordering={isReorderable}
                      //disableSelectionOnClick={view === 'edit'}
                      disableMultipleSelection
                      // hideFooter
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    No Data Available
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                Nothing to Display
              </div>
            )}
          </Grid>
        </Grid>
      </div>
      {item?.service !== 'citation-court' && (
        <LookUpCodesAddEditDialog
          open={open}
          closeDialog={handleClose}
          mode={mode}
          data={editableRow}
          dictionary={dictionary}
          table={item.table}
          currentService={item?.service}
          title={item?.label}
          codeCategory={item?.codeCategory}
          selectedAgencyId={agencyFilter || null}
          agencyCodeServices={agencyCodeServices}
        />
      )}
      {showReportDialog && (
        <ReportsDialog open={showReportDialog} onClose={onReportDialogClose} report={reportData} />
      )}
    </Content>
  );
}

export default LookupCodes;
